module.exports = __webpack_public_path__ + "img/map-placeholder.4ce89fc8.png";